<template>
  <ResearchGalleryPage
    page-title="机构设置"
    section-label="建制沿革"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuJigoushezhi',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: {
        path: '/lanhu_jigouyulishi',
        query: { item: 'evolution-history', subitem: 'organization-setup' }
      },
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '机构设置',
          kicker: '建制沿革',
          columns: 1,
          description: [
            '早期，新闻与传播研究所内设机构有：',
            '科研组织处、马克思主义新闻学研究室、中国共产党报业史研究室、中国报业史研究室、世界新闻研究室、广播电视研究室、新闻摄影研究室、编辑出版室、图书资料室及行政办公室。',
            '马克思主义新闻学研究室曾先后易名为新闻理论研究室、新闻学研究室，2010 年恢复现名。1984 年，中国共产党报业史研究室和中国报业史研究室整合为中国报刊史研究室，新闻摄影研究室并入广播电视研究室，同年 5 月新成立新闻法研究室。1988 年增设传播研究室。1991 年，将世界新闻研究室和传播研究室合并为世界新闻与传播研究室，2001 年更名为传播学研究室。1999 年成立网络与数字化传媒研究室，2010 年更名为网络学研究室。2009 年，组建成立信息室。2010 年，中国新闻事业室更名为媒介研究室。',
            '目前，所内机构设置如下：'
          ],
          items: [
            {
              src: require('./assets/html/organization-chart.jpg'),
              caption: '新闻与传播研究所机构设置图'
            }
          ]
        }
      ]
    };
  }
};
</script>
